<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - Ce composant est la vue qui gère le formulaire des apports organiques
  - SD version du 12/04/2019 11:14:55
  -->
<template>
  <div class="contribution">
    <h1 class="form-title">{{ $t('contribution_title') }}</h1>
    <v-form v-model="validContribution" ref="contributionForm">
      <div class="contour">
        <v-layout row wrap align-center>
          <v-flex xs9 v-html="$t('contribution_burry-switch_label')"></v-flex>
          <v-flex xs3 style="display: flex; align-items: center;">
            <span class="moyen">{{ $t("no") }}&nbsp;&nbsp;</span>
            <v-switch
              v-model="organicContribution"
              @change="switchContribution"
              color="primary"
              class="switch2e"
            ></v-switch>
            <span class="moyen">{{ $t("yes") }}</span>
          </v-flex>

          <v-flex xs12>
            <v-select
              :disabled="contributionEnabled"
              v-model="contributionTypeValue"
              :items="contributionTypeList"
              item-text="apport"
              item-value="apport"
              color="primary"
              return-object
              ref="contributionTypeInput"
              :label="$t('contribution_contrib-select_label')"
              single-line
              @change="contributionTypeSelected"
              :rules="[reglesContribution.contribType]"
            ></v-select>
          </v-flex>

          <v-flex xs12 wrap>
            <p :disabled="contributionEnabled">{{ $t("contribution_quantity_label")}}</p>
            <v-slider
              :disabled="contributionEnabled"
              v-model="contributionTypeQuantity"
              ref="contributionSlider"
              :thumb-label="quantityLabel"
              :label="bornesContribQuantity"
              inverse-label
              always-dirty
              :min="bornesContrib[0]"
              :max="bornesContrib[1]"
              @change="contributionQuantityChange"
              class="label-small"
            ></v-slider>
          </v-flex>
        </v-layout>
      </div> <!--.contour-->
    </v-form>
    <p></p>
    <v-form v-model="validResidues" ref="residuesForm">
      <div class="contour">
        <v-layout row wrap align-center>
          <v-flex xs9 v-html="$t('contribution_burry_switch_label')"></v-flex>
          <v-flex xs3 style="display: flex; align-items: center;">
            <span class="moyen">{{ $t("no") }}&nbsp;&nbsp;</span>
            <v-switch
              v-model="residueContribution"
              @change="switchResidue"
              color="primary"
              class="switch2e"
            ></v-switch>
            <span class="moyen">{{ $t("yes") }}</span>
          </v-flex>

          <v-flex xs12>
            <v-select
              :disabled="!residueEnabled"
              v-model="residueCulture"
              :items="residueCultureList"
              item-text="culture"
              item-value="culture"
              color="primary"
              ref="residueCultureType"
              :label="$t('contribution_culture_label')"
              return-object
              single-line
              @change="residueCultureSelected"
              :rules="[reglesContribution.culture]"
            ></v-select>
          </v-flex>

          <v-flex xs12 wrap>
            <v-text-field
              :disabled="residueYieldEnabled"
              :label="$t('contribution_culture_yeild_label')"
              :suffix="bornesResidueYield"
              clearable
              ref="cultureYieldInput"
              id="cultureYieldInput"
              type="number"
              v-model="residueYield"
              :rules="[reglesContribution.rendement]"
              @change="residueCultureYieldChange"
              @focus="$event.target.select()"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 wrap>
            <p :disabled="residueUsedEnabled">
              {{ $t("contribution_burry_quantity_label") }}
            </p>
            <v-slider
              :disabled="residueUsedEnabled"
              v-model="residueUsed"
              :thumb-label="residueLabel"
              :label="$t('tha')"
              inverse-label
              always-dirty
              :min="0"
              :max="bornesResidue[1]"
              @change="residueQuantityChange"
              class="label-small"
            ></v-slider>
          </v-flex>
        </v-layout>
      </div> <!--.contour-->
    </v-form>
    <v-layout row nowrap justify-end>
      <v-btn color="primary" class="btn-ks white--text" @click="nextScreen">{{ $t("btn_next") }}</v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "Contribution",
  data() {
    return {
      validContribution: false,
      validResidues: false,
      firstLaunch: true,

      organicContribution: false,
      contributionList: false,
      contributionType: false,
      quantityLabel: false,
      contributionTypeValue: false,
      contributionTypeQuantity: 0,
      bornesContrib: [0, 1],

      residueContribution: false,
      bornesResidue: [0, 1],
      // residueYieldEnabled: false,
      //residueUsedEnabled: false,
      residueYield: 0,
      residueUsed: 0,
      residueLabel: false,
      residueCulture: false,
      residueYieldChange: false,

      reglesContribution: {
        contribType: value => {
          if (this.organicContribution) {
            return !!value || this.$i18n.t("contribution_contrib-select_error");
          } else {
            return true;
          }
        },
        culture: value => !!value || this.$i18n.t("yield_err_culture"),
        rendement: value =>
          !!this.rendementResiduesValid(value) ||
          this.$i18n.t("yield_err_bornes")
      }
    };
  },

  computed: {
    contributionEnabled() {
      return this.$store.getters.getContributionEnabled
    },

    residueEnabled() {
      return !this.$store.getters.getResiduesEnabled
    },

    residueCultureList() {
      return this.$store.getters.getCulturesList;
    },

    residueYieldEnabled() {
      let ret = this.residueEnabled && this.residueCulture;
      return !ret;
    },

    residueUsedEnabled() {
      let ret =
        this.residueEnabled &&
        !this.residueYieldEnabled &&
        this.residueYieldChange;
      return !ret;
    },

    contributionTypeList() {
      return this.$store.getters.getContributionList;
    },

    bornesContribQuantity() {
      if (this.contributionTypeValue === false) {
        return this.$i18n.t("tha");
      } else {
        return `${this.contributionTypeQuantity} ${this.$i18n.t("tha")} (${
          this.bornesContrib[0]
        } min - ${this.bornesContrib[1]} max)`;
      }
    },

    bornesResidueYield() {
      if (this.residueCulture === false) {
        return this.$i18n.t("tha");
      } else {
        return `${this.$i18n.t("tha")} (${this.bornesResidue[0]} min - ${
          this.bornesResidue[1]
        } max)`;
      }
    },

    globalEnabled() {
      return !(this.residueEnabled || !this.contributionEnabled);
    }

    // maxResidueUsed() {
    //   const max = this.$options.filters.intLocal(this.residueYield * 0.75);
    //   console.log(max);
    //   return max;
    // },

    // autorizeNext() {
    //   return !(!this.contributionEnabled || this.residueEnabled);
    // }
  },

  methods: {
    rendementResiduesValid(value) {
      return value >= this.bornesResidue[0] && value <= this.bornesResidue[1];
    },

    switchContribution() {
      this.$store.dispatch("switchContribution");
    },

    switchResidue() {
      this.$store.dispatch("switchResidue");
    },

    contributionTypeSelected(value) {
      this.contributionType = value;
      this.bornesContrib[0] = value.borne_basse;
      this.bornesContrib[1] = value.borne_haute;
      const contributionObject = {
        contributionEnabled: this.contributionEnabled,
        contributionType: this.contributionType,
        contributionQuantity: 1
      };
      // lance le stockage dans le store de cette partie du formulaire
      this.$store.dispatch("storeContribution", contributionObject);
    },

    contributionQuantityChange(value) {
      this.quantityLabel = "always";
      const contributionObject = {
        contributionEnabled: this.contributionEnabled,
        contributionType: this.contributionType,
        contributionQuantity: value
      };
      // lance le stockage dans le store de cette partie du formulaire
      this.$store.dispatch("storeContribution", contributionObject);
    },

    residueCultureSelected(value) {
      console.log(value);

      this.residueCulture = value;
      this.bornesResidue[0] = value.bornebasse;
      this.bornesResidue[1] = value.bornehaute;

      console.info("Appel validation"); // FIXME
      if (this.firstLaunch) {
        this.firstLaunch = false;
      } else {
        this.yieldOk = !this.$refs.residuesForm.validate();
      }

      // pour la sélection automatique du textfield de rendement (focus)
      const elem = this.$el.querySelector('#cultureYieldInput');
       if (elem) this.$nextTick(() => { elem.focus() });
    },

    residueCultureYieldChange(value) {
      console.log(value);
      this.residueYieldChange = true;
      this.residueLabel = "always";
      let used75 = Math.round(parseFloat(value) * 0.75);
      if (used75 < this.bornesResidue[0]) {
        this.residueUsed = this.bornesResidue[0];
      } else {
        this.residueUsed = used75;
      }

      const residuesObject = {
        residuesCulture: this.residueCulture,
        residuesYield: Math.round(parseFloat(this.residueYield)),
        residuesUsed: this.residueUsed
      };

      this.$store.dispatch("storeResidues", residuesObject);
    },

    residueQuantityChange(value) {
      const residuesObject = {
        residuesCulture: this.residueCulture,
        residuesYield: Math.round(parseFloat(this.residueYield)),
        residuesUsed: value
      };
      this.$store.dispatch("storeResidues", residuesObject);
    },

    goNext() {
      this.$store.dispatch("updateRoutes", this.$router.currentRoute.path).then(
        () => {
          this.$router.push({ path: "sol" }); // on change de page
        },
        () => {
          console.error("Erreud de routage ");
        }
      );
    },

    // validation des formulaires et passage à l'étape suivante
    nextScreen() {
      let validContrib = false,
        validResidues = false;

      // si les nextScreen sont activées
      if(!this.contributionEnabled) {
        validContrib = this.$refs.contributionForm.validate();

        // si les résidus ne sont pas activés il faut forcer les résidus à true
        // if(validContrib && !this.residueEnabled) {
        //   validResidues = true;
        // }
      }

      // si les résidus sont activés
      if(this.residueEnabled) {
        validResidues = this.$refs.residuesForm.validate();

        // si les contribution ne sont pas activées il faut forcer le contrib à true
        // if(validResidues && this.contributionEnabled) {
        //   validContrib = true;
        // }
      }

      if (!this.globalEnabled) {
        console.warn("No Go");
        if (validContrib) {
          console.log("Validcontrib ok");
          if (this.residueEnabled) {
            if(validResidues) {
              console.info("Contrib & Residus ok => GO");
              this.goNext();
              // this.$router.push({path: 'sol'}); // on change de page
            } else {
              console.warn("Residus KO => No Go");
            }
          } else {
            console.info("Contrib seul ok => GO");
            this.goNext();
            // this.$router.push({path: 'sol'}); // on change de page
          }
        }
        if (validResidues) {
          if (!this.contributionEnabled) {
            if(validContrib) {
              console.info("Residus & Contrib ok => GO");
              this.goNext();
              // this.$router.push({path: 'sol'}); // on change de page
            } else {
              console.warn("Contrib KO => No Go");
            }
          } else {
            console.info("Residus seul ok => GO");
            this.goNext();
            // this.$router.push({path: 'sol'}); // on change de page
          }
        }
      } else {
        console.info("Go");
        this.goNext();
      }
    } // contribution
  }, // fin des méthodes
  mounted() {
    // lorsque le composant est charg
    if(this.$store.state.formulaire.contribution.contributionEnabled) {
      this.organicContribution = true;
      this.contributionTypeValue = this.$store.state.formulaire.contribution.contributionType;
      this.contributionTypeSelected(this.contributionTypeValue);
      this.$refs.contributionSlider.$el.focus();
      this.contributionTypeQuantity = this.$store.state.formulaire.contribution.contributionQuantity;
    }
    if(this.$store.state.formulaire.contribution.residuesEnabled) {
      this.residueContribution = true;
      this.residueCulture = this.$store.state.formulaire.contribution.residuesCulture;
      this.residueCultureSelected(this.residueCulture);
      this.residueYield = this.$store.state.formulaire.contribution.residuesYield;
      this.residueCultureYieldChange(this.residueYield);
      this.residueYieldChange = true;
      this.residueUsed = this.$store.state.formulaire.contribution.residuesUsed;
    }
  }
};
</script>

<style lang="scss">
.switch2e {
  &.v-input--switch {
    /*padding-top: 0;*/
    height: 2em;
    margin-top: 0;
    flex: 0 0 auto;
  }
}
</style>
